import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap"; 
import DataTable from "react-data-table-component";
import PageHeader from "../../components/common/PageHeader";
import useDepartmentSubmit from "../../hooks/useDepartmentSubmit";
import DepartmentServices from "../../services/DepartmentServices";
import Error from "../../components/Input/Error";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync"; 
import { useLocation } from 'react-router-dom';
import DropDownService from "../../services/DropDownService";

function Departments() {
    const [modalheader, setModalHeader] = useState(null);
    const [rowData, setrowData] = useState([]);
    const [columnsT, setcolumnT] = useState([]);
    const [deptID, setDeptID] = useState("");
    const { data, loading } = useAsync(() => DepartmentServices?.getAllDepartment());
    const location = useLocation();
    const { pathname } = location;
    const [isEditModalData, setIsEditModalData] = useState(null);

    const { data:permissionData } = useAsync(() => DropDownService.getModulePermissions({ path:pathname, userId:localStorage.id})); 
    var addPermission = typeof permissionData?.data?.add === 'undefined' ? 1: permissionData?.data?.add; 
    var viewPermission = typeof permissionData?.data?.view === 'undefined' ? 1: permissionData?.data?.view;
    var editPermission = typeof permissionData?.data?.edit === 'undefined' ? 1: permissionData?.data?.edit; 
    var deletePermission = typeof permissionData?.data?.delete === 'undefined' ? 1: permissionData?.data?.delete; 
    var listPermission = typeof permissionData?.data?.list === 'undefined' ? 1: permissionData?.data?.list;  

    const {
        register,
        onSubmit,
        handleSubmit,    
        deleteDepartment,  
        ShowEditValues, 
        errors,
        isModal, setIsModal,
        status, setStatus,
        isDeleteModal, setIsDeleteModal
      } = useDepartmentSubmit(deptID);   

      const getAllDepartments = async (data) => {   
        const result = data;
        setrowData(result?.department); 
        
        var rowData = result?.department;
        console.log("rowdtaa", rowData); 
        var columnsT = "";
        columnsT = [
            {
                name: "S.No.", 
                selector: (row, index) => index + 1,
                sortable: true,
            },
            // {
            //     name: "DEPARTMENT HEAD",
            //     selector: (rowData) => rowData?.departmentHead,
            //     sortable: true,
            // },
            {
                name: "DEPARTMENT NAME",
                selector: (rowData) => rowData?.departmentName,
                sortable: true
            }, 
            { 
                    name: "STATUS",
                    selector: (rowData) => rowData?.status,
                    sortable: true,
                    cell: row => <span className={`badge ${row.status === "Active" ? 'bg-success' : "bg-warning"}`}>{row.status}</span>
                }, 
            // {
            //     name: "EMPLOYEE UNDER WORK",
            //     selector: (rowData) => rowData?.employeeUnderWork,
            //     sortable: true
            // },
            { 
                name: "ACTION", 
                selector: (rowData) => { },  
                sortable: true,
                cell: (rowData) => (<div className="btn-group" role="group" aria-label="Basic outlined example">
                    {editPermission === 1 && (<button className="btn btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#depedit" onClick={() => { setIsModal(true); ShowEditValues(rowData);  setDeptID(rowData?._id); setModalHeader('Edit Department') }}><i className="icofont-edit text-success"></i></button>)}
                    {deletePermission === 1 && (<button className="btn btn-outline-secondary deleterow" onClick={()=> {setIsDeleteModal(true);  setDeptID(rowData?._id); }}><i className="icofont-ui-delete text-danger"></i></button> )}
                </div>) 
            } 
    
        ]
        setcolumnT(columnsT); 
        // setLoading(false); 
    } 

    useEffect(()=>{
        getAllDepartments(data); 
    }, [data]);
 
    return (
        <div className="container-xxl">
            <PageHeader addPermission={addPermission} headerTitle="Department" renderRight={() => {
                return <div className="col-auto d-flex w-sm-100">
                    <button className="btn btn-dark btn-set-task w-sm-100" onClick={() => { setIsModal(true); setDeptID(""); setModalHeader('Add Department') }}><i className="icofont-plus-circle me-2 fs-6"></i>Add Department</button>
                </div>
            }} />
            {listPermission === 1 && (
            <div className="row clearfix g-3">
                <div className="col-sm-12">
                    <DataTable 
                        title='Department'
                        columns={columnsT}
                        data={rowData}
                        defaultSortField="title"
                        pagination
                        selectableRows={false} 
                        className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                        highlightOnHover={true}
                        progressPending={loading}
                        progressComponent={<ModalLoading loading={loading} />}
                    />
                </div>
            </div>
            )}
            <Modal centered show={isModal} onHide={() => { setIsModal(false);}}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">{modalheader}</Modal.Title>
                </Modal.Header>
                <Modal.Body> 
                    <div className="deadline-form">
                        
                            <div className="row g-3 mb-3"> 
                                <div className="mb-3">  
                                    <label htmlFor="departmentName" className="form-label">Department Name</label> 
                                    <input type="text" className="form-control"  id="departmentName" name="departmentName" {...register(`departmentName`, { required: `Department Name is required!`})} />
                                    <Error errorName={errors?.departmentName} /> 
                                </div>
                                <div className="col-lg-6"> 
                                    <label className="form-label">Status</label> 
                                    <br/>  
                                    <label className="fancy-radio parsley-error"> 
                                        <input type="radio" name="status" value="Active"  checked={(status === "Active") ? "checked": ""} onChange={(e) => { setStatus(e.target.value); }} required data-parsley-errors-container="#error-radio" data-parsley-multiple="status" data-parsley-id="43" />
                                        <span className="px-2"><i></i>Active</span>
                                    </label> 
                                    <label className="fancy-radio"> 
                                        <input type="radio" name="status" value="InActive" checked={(status === "InActive") ? "checked": ""} onChange={(e) => { setStatus(e.target.value); }} data-parsley-multiple="status" />
                                        <span className="px-2"><i></i>InActive</span>
                                    </label>  
                                </div>
                            </div> 
                    </div>
                </Modal.Body>
                <Modal.Footer>   
                    <button type="submit" className="btn btn-primary">{deptID ? "Update " : "Add"}</button>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsModal(false) }}>Cancel</button>
                </Modal.Footer>
                </form> 
            </Modal>

            {/* Department delete modal */} 
            <Modal show={isDeleteModal} centered onHide={() => { setIsDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Delete Department</Modal.Title> 
                </Modal.Header>  
                <Modal.Body className="justify-content-center flex-column d-flex"> 
                    <i className="icofont-ui-delete text-danger display-2 text-center mt-2"></i> 
                    <p className="mt-4 fs-5 text-center">Are You Sure! Want to Delete Department?</p>   
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsDeleteModal(false) }}>Cancel</button>
                    <button type="button" className="btn btn-danger color-fff" onClick={() => deleteDepartment(deptID)}>Delete</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}


export default Departments; 